export default class ApiService {
  constructor () {
    this.baseUrl = window.location.origin + '/'
  }

  getMenuData () {
    return fetch('sampledata.json', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      return response.json()
    })
  }

  addNewApp (body) {
    var sentBody = JSON.stringify(body)
    return fetch(this.baseUrl + 'api/add/app', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      },
      body: sentBody
    }).catch((err) => {
      // console.log('setText error: ', err)
      return err
    })
  }

  getAppList () {
    return fetch(this.baseUrl + 'api/applist', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (response.status === 401) {
        throw response.text()
      }
      return response.json()
    })
  }

  postAppList (body) {
    var sentBody = JSON.stringify(body)
    // console.log('setText: ', url)
    return fetch(this.baseUrl + 'api/update/applist', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      },
      body: sentBody
    }).catch((err) => {
      // console.log('setText error: ', err)
      return err
    })
  }

  getSpecificApp (name) {
    return fetch(this.baseUrl + name + '/appsettings', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      return response.json()
    })
  }

  getText (url) {
    return fetch(this.baseUrl + 'api/' + url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      }
    }).then(response => {
      return response.json()
    })
  }

  postText (url, textData) {
    var sentBody = JSON.stringify(textData)
    return fetch(this.baseUrl + 'update/' + url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      },
      body: sentBody
    }).then((data) => {
      if (data.status !== 200) {
        return Promise.reject(new Error('save failed'))
      }
    })
  }

  postAppLogo (name, body) {
    var sentBody = JSON.stringify(body)
    return fetch(this.baseUrl + name + '/appsettings/upload/logo', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      },
      body: sentBody
    }).then((data) => {
      if (data.status !== 200) {
        return Promise.reject(new Error('upload failed'))
      } else {
        return data
      }
    })
  }

  postAppColors (name, body) {
    var sentBody = JSON.stringify(body)
    // console.log('setText: ', name + '/appsettings/upload/colors')
    return fetch(this.baseUrl + name + '/appsettings/upload/colors', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      },
      body: sentBody
    }).catch((err) => {
      // console.log('setText error: ', err)
      return err
    })
  }

  postAddNewLanguage (name, body) {
    var sentBody = JSON.stringify(body)
    // console.log('setText: ', name + '/appsettings/upload/colors')
    return fetch(this.baseUrl + 'api/' + name + '/add/language', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      },
      body: sentBody
    }).catch((err) => {
      // console.log('setText error: ', err)
      return err
    })
  }

  postSaveDocumentByAppAndName (name, body) {
    var sentName = name.replace(' ', '')
    var sentBody = JSON.stringify(body)
    return fetch(this.baseUrl + 'api/' + sentName + '/' + body.title + '/save', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      },
      body: sentBody
    }).catch((err) => {
      // console.log('setText error: ', err)
      return err
    })
  }

  postAppFont (name, body) {
    var sentBody = JSON.stringify(body)
    // console.log('set Font: ', name + '/appsettings/upload/font')
    // console.log('body: ', body)
    return fetch(this.baseUrl + name + '/appsettings/upload/font', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*'
      },
      body: sentBody
    }).catch((err) => {
      // console.log('setText error: ', err)
      return err
    })
  }
}
